import './lib/AnimationEasing';
import "./lib/AnalyticsSetup";

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuToggle, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	focusLock: {
		dialog: '.menu',
		return: '.menuToggle--open',
		toggle: '.menuToggle--close'
	},
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(400, 'easeOutExpo')
	]
});

const focusLock = function(){
	const dialog = document.querySelector('[role="dialog"]');
	if (dialog){
		const firstFocusableElement: HTMLElement = dialog.querySelector('.first-focusable-element');
		const lastFocusableElement: HTMLElement = dialog.querySelector('.last-focusable-element');

		dialog.addEventListener('keydown', function (event: KeyboardEvent) {
			if (event.target == firstFocusableElement && event.key == 'Tab' && event.shiftKey) {
				event.preventDefault();
				lastFocusableElement.focus();
			} else if (event.target == lastFocusableElement && event.key == 'Tab' && !event.shiftKey) {
				event.preventDefault();
				firstFocusableElement.focus();
			}
		});
	}
}
focusLock();

